module.exports = __webpack_public_path__ + "img/about_us.44937ed8.png";